module.exports = __webpack_public_path__ + "media/customizations/sunbridge/logo-aeafc36e4a8bad33c8e55622a12ec697.png";